export default {"src":"/_next/static/media/header-logo.80e7e742.svg","height":32,"width":371,"blurWidth":0,"blurHeight":0};